import React from 'react';
import bn from '../utils/bemnames';
import InnerHTML from 'dangerously-set-html-content'

const bem = bn.create('banner');

interface IProps {
  isMobile: boolean;
  bannerCodeDesktop: string|null;
  bannerCodeMobile: string|null;
}

class Banner extends React.Component<IProps> {

  getBannerCode(): string|null {
    const {isMobile, bannerCodeDesktop, bannerCodeMobile} = this.props;
    return isMobile ? bannerCodeMobile : bannerCodeDesktop;
  }
  
  render() {
    const { isMobile } = this.props;
    const bannerCode = this.getBannerCode();

    return (
      <>
        {bannerCode && <div className={bem.e('wrapper')}>
          <div className={isMobile ? bem.e('mobile') : bem.e('desktop')}>
            <InnerHTML html={bannerCode}/>
          </div>
        </div>}
      </>
    )
  }
}

export default Banner;
